import { Trans, useTranslation } from 'react-i18next';
import { Tabs as MuiTabs, Tab, SxProps, Stack } from '@mui/material';

import { StyledTooltip } from '@common/components/StyledTooltip';
import { Module } from '@/modules/app/types';
import { useAppStore } from '@/modules/app/store/useAppStore';

export type TabProps = {
  label: string;
  trans: string;
  disableTab: boolean;
  id: Module;
};

type Props = {
  tabLabels: TabProps[];
  onChange: (id: Module) => void;
  sx?: SxProps;
};

export const TabsComponent = ({ tabLabels, onChange, sx }: Props) => {
  const activeModule = useAppStore((state) => state.activeModule);
  const { t } = useTranslation(['interface']);

  return (
    <Stack justifyContent='center' sx={sx}>
      <MuiTabs value={activeModule} onChange={(e, value: Module) => onChange(value)} sx={{ pb: 0, borderBottom: '1px solid #E0E0E0' }}>
        {tabLabels.length > 0 &&
          tabLabels.map((tab) => (
            <Tab
              value={tab.id}
              key={tab.label}
              disabled={tab.disableTab}
              label={
                <StyledTooltip offset={15} title={t(`${tab.trans}.tooltip`)} placement='bottom'>
                  <span>
                    <Trans i18nKey={`${tab.trans}.label`} ns='interface'>
                      {tab.label}
                    </Trans>
                  </span>
                </StyledTooltip>
              }
            />
          ))}
      </MuiTabs>
    </Stack>
  );
};
